
















import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { EvalSettingSimple } from '@/models/evalSetting/eval-setting-simple';
import moment from 'moment';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GExamListDeadlineInput',
  computed: {},
  methods: {},
})
export default class GExamListDeadlineInput extends Mixins(GPageBase) {
  tempDeadline: string = ''; // 終了日の最終変更結果を代入する

  @Prop() evalSettingSimple: EvalSettingSimple;
  mounted() {}

  get endSchoolYear(): number {
    return globalModule.endSchoolYear;
  }

  handleChangeDeadline(deadline: string) {
    this.tempDeadline = deadline;
  }

  handleOKDeadline() {
    const tempBeforeDeadline: Date = this.evalSettingSimple.deadline;
    this.evalSettingSimple.deadline = this.tempDeadline !== '' ? moment(this.tempDeadline).toDate() : tempBeforeDeadline;
    this.$emit('handleUpdate', this.evalSettingSimple, tempBeforeDeadline);
  }

  // DatePickerのdisable範囲を設定
  dateOption() {
    const evalSettingSimple: EvalSettingSimple = this.evalSettingSimple;
    const endSchoolYear: number = [1, 2, 3].includes(moment(evalSettingSimple.startTime).month() + 1) ? moment(evalSettingSimple.startTime).year() : moment(evalSettingSimple.startTime).year() + 1;
    return {
      disabledDate(date: Date) {
        //終了日を開始日+1より手前の日付で設定を不可能にする
        return (date && moment(date) < moment(evalSettingSimple.startTime)) || moment(new Date(endSchoolYear, 3, 1)) <= moment(date);
      },
    };
  }
}
